import React from 'react';

const NewsBanner: React.FC = () => {
  return (
    <a href="/" style={{ marginBottom: '16px' }}>
      <div className="flex items-center justify-between gap-3 mb-6 px-4 py-3 bg-black text-white rounded-xl max-w-2xl w-full mx-auto shadow-md" dir="rtl">
        {/* دکمه ویژگی جدید */}
        <div
          className="flex items-center justify-center px-3 py-1 rounded-full text-black"
          style={{ backgroundColor: 'rgb(255, 178, 36)', color: 'black' }}
        >
          ویژگی جدید
        </div>

        {/* متن خبر */}
        <span className="text-sm text-right flex-1 truncate">
          ویژگی پایگاه دانش اضافه شد - از این به بعد همه اطلاعات در اختیار شماست
        </span>

        {/* آیکن فلش */}
        <span className="flex-shrink-0 ml-2"> {/* کاهش فاصله با margin-left */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="transparent"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-arrow-left"
          >
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
        </span>
      </div>
    </a>
  );
};

export default NewsBanner;
